import { RelayPageDataTable } from "@constellation-academy/epic-ui";
import { useContext } from "react";
import { useTranslation } from "@i18n/hooks";
import { offersTable_QueryFragment$key } from "@relay/offersTable_QueryFragment.graphql";
import { type offersTable_Refetch } from "@relay/offersTable_Refetch.graphql";
import { type offersTable_UnpublishedLearnableFragment$key } from "@relay/offersTable_UnpublishedLearnableFragment.graphql";
import { DEFAULT_ROWS_COUNT } from "./offers-table.consts";
import { UNPUBLISHED_LEARNABLE_FRAGMENT, QUERY_FRAGMENT } from "./offers-table.graphql";
import { wrapperClass } from "./offers-table.styles";
import { type OffersTableProps } from "./offers-table.types";
import { IdDisplayField } from "../../../../components/id-display-field";
import { OffersScreenContext } from "../../offers.context";
import { DeleteCourseLearnableButtonComponent } from "../delete-course-learnable-button";
import { EditCourseLearnableButton } from "../edit-course-learnable-button";

export const OffersTable = ({ queryFragmentRef }: OffersTableProps) => {
	const { t } = useTranslation("common");
	const { connectionId, setConnectionId, filters } = useContext(OffersScreenContext);

	const handleOnConnectionIdChange = (id?: string | null) => {
		id && setConnectionId(id);
	};

	return (
		<RelayPageDataTable<
			offersTable_Refetch,
			offersTable_QueryFragment$key,
			offersTable_UnpublishedLearnableFragment$key
		>
			queryFragment={QUERY_FRAGMENT}
			parentFragmentRef={queryFragmentRef}
			nodeInlineFragment={UNPUBLISHED_LEARNABLE_FRAGMENT}
			extractConnection={(data) => data.Admin.Learnable.UnpublishedLearnables}
			filters={filters}
			rowsCount={DEFAULT_ROWS_COUNT}
			onConnectionIdChange={handleOnConnectionIdChange}
		>
			{(Column) => (
				<>
					<Column
						header={t("table.id")}
						body={(learnable) => <IdDisplayField id={learnable.id} />}
						style={{ width: "3%" }}
					/>
					<Column
						header={t("table.name")}
						body={(learnable) =>
							learnable.root?.structureDefinition.title ??
							t("offers.unknownCourse", { id: learnable.id })
						}
					/>
					<Column
						header={t("offers.published")}
						body={(learnable) =>
							learnable.root?.hasBeenPublishedOnce
								? t("actions.yes")
								: t("actions.no")
						}
						style={{ width: "7%" }}
					/>
					<Column
						header={t("offers.type")}
						body={(learnable) =>
							learnable.kind === "Course" ? t("offers.courseKind") : ""
						}
						style={{ width: "7%" }}
					/>
					<Column
						header={t("table.actions")}
						style={{ width: "8%" }}
						body={(item) => (
							<div className={wrapperClass}>
								<EditCourseLearnableButton learnableFragmentRef={item} />
								<DeleteCourseLearnableButtonComponent
									connectionId={connectionId}
									learnableFragmentRef={item}
								/>
							</div>
						)}
					/>
				</>
			)}
		</RelayPageDataTable>
	);
};
